module.exports = __webpack_public_path__ + "assets/ea824c58620071632788d3e38cf817ae.jpg";